import { render, staticRenderFns } from "./config_notice.vue?vue&type=template&id=cd34e5dc&scoped=true"
import script from "./config_notice.vue?vue&type=script&lang=js"
export * from "./config_notice.vue?vue&type=script&lang=js"
import style0 from "./config_notice.vue?vue&type=style&index=0&id=cd34e5dc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd34e5dc",
  null
  
)

export default component.exports